// Title field for TaskForm when not rendered in the modal header.
import { Box, TextField } from '@mui/material';
import { useT } from '@/i18n/useT';
import { renderTitleError } from '@/features/tasks/components/forms/TaskFormSubtaskRows';

export function TaskFormTitleField({ task, errors, handleChange }) {
  const t = useT();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      <TextField
        id="title"
        name="title"
        type="text"
        value={task.title || ''}
        onChange={/** @type {any} */ (handleChange)}
        required
        fullWidth
        size="small"
        autoFocus
        variant="standard"
        placeholder={t('taskform.titlePlaceholder', 'Taaktitel')}
        inputProps={{ 'aria-label': t('taskform.titleLabel', 'Title:') }}
        InputProps={{
          disableUnderline: true,
          sx: { fontSize: '1.15em', fontWeight: 700 },
        }}
      />
      {renderTitleError(errors)}
    </Box>
  );
}
